import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "page-wr" }
const _hoisted_2 = { class: "title-wrapper" }
const _hoisted_3 = { class: "title-row" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "actions"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 1,
  class: "actions"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "spinner"
}
const _hoisted_12 = {
  key: 1,
  class: "hold-details-wrapper"
}
const _hoisted_13 = { class: "card-column-second" }
const _hoisted_14 = { class: "card" }
const _hoisted_15 = { class: "card-details-rows-wrapper card-details-rows-wrapper--buyer" }
const _hoisted_16 = { class: "card-hold-details-row" }
const _hoisted_17 = { class: "hold-row-value" }
const _hoisted_18 = { class: "card-hold-details-row" }
const _hoisted_19 = { class: "hold-row-value" }
const _hoisted_20 = { class: "card-hold-details-row" }
const _hoisted_21 = { class: "hold-row-value" }
const _hoisted_22 = {
  key: 0,
  class: "card-hold-details-row"
}
const _hoisted_23 = { class: "hold-row-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode($setup["Breadcrumbs"], {
          crumbs: $setup.crumbs,
          backButton: true
        }, null, 8, ["crumbs"]),
        ($setup.initialHold && ($setup.canManageLot || $setup.isSameBusinessOwner))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              ($setup.initialHold?.status === $setup.InitialHoldStatus.APPROVED)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["button button decline", { 'disabled-business-owner': !$setup.isSameBusinessOwner }]),
                      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.isConfirmCancelModalOpen = true)),
                      disabled: _ctx.disabledCancelButton || !$setup.isSameBusinessOwner || $setup.loading
                    }, "Cancel Hold", 10, _hoisted_6),
                    _createElementVNode("button", {
                      class: _normalizeClass(["button button extend-hold", { 'disabled-business-owner': !$setup.isSameBusinessOwner }]),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.isExtendModalOpen = true)),
                      disabled: !$setup.isSameBusinessOwner || $setup.loading
                    }, "Extend Hold", 10, _hoisted_7)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["button button decline", { 'disabled-business-owner': !$setup.isSameBusinessOwner }]),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.isDeclineModalOpen = true)),
                      disabled: $setup.disabledDeclineButton || !$setup.isSameBusinessOwner || $setup.loading
                    }, "Decline", 10, _hoisted_9),
                    _createElementVNode("button", {
                      class: _normalizeClass(["button button approve-hold", { 'disabled-business-owner': !$setup.isSameBusinessOwner }]),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.isOpenApproveModal = true)),
                      disabled: $setup.disabledApproveButton || !$setup.isSameBusinessOwner || $setup.loading
                    }, "Approve", 10, _hoisted_10)
                  ]))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11))
      : ($setup.lot && $setup.stage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode($setup["InitialHoldLotDetailsCard"], {
              lot: $setup.lot,
              stage: $setup.stage
            }, null, 8, ["lot", "stage"]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode($setup["InitialHoldDetailsCard"], {
                data: { ...$setup.initialHold.leadsDetails, holderType: $setup.initialHold?.holderType, companyDetails: $setup.initialHold?.companyDetails },
                title: `${$setup.initialHold.purchaserDetails ? 'Builder / Channel Partner Details' : 'Purchaser Details'}`
              }, null, 8, ["data", "title"]),
              ($setup.initialHold?.purchaserDetails)
                ? (_openBlock(), _createBlock($setup["InitialHoldDetailsCard"], {
                    key: 0,
                    data: $setup.initialHold.purchaserDetails,
                    title: 'Purchaser Details'
                  }, null, 8, ["data"]))
                : _createCommentVNode("", true),
              ($setup.initialHold?.builderOrChannelPartnerDetails)
                ? (_openBlock(), _createBlock($setup["InitialHoldDetailsCard"], {
                    key: 1,
                    data: $setup.initialHold?.builderOrChannelPartnerDetails,
                    title: 'Builder / Channel Partner Details'
                  }, null, 8, ["data"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_14, [
                _cache[23] || (_cache[23] = _createElementVNode("h3", { class: "card-title-bold" }, "Hold Request Details", -1)),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "hold-row-title" }, "Expiration Date", -1)),
                    _createElementVNode("div", _hoisted_17, _toDisplayString($setup.expirationDateText), 1)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "hold-row-title" }, "Created Date", -1)),
                    _createElementVNode("div", _hoisted_19, _toDisplayString($setup.formatDate($setup.initialHold?.createdAt)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "hold-row-title" }, "Status", -1)),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["badge hold-status", $setup.getInitialHoldStatusClass($setup.initialHold.status)])
                      }, _toDisplayString($setup.getInitialHoldStatusText($setup.initialHold.status)), 3)
                    ])
                  ]),
                  ($setup.holdBusiness)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _cache[22] || (_cache[22] = _createElementVNode("div", { class: "hold-row-title" }, "Business", -1)),
                        _createElementVNode("div", _hoisted_23, _toDisplayString($setup.capitalizeString($setup.holdBusiness.name)), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
    _createVNode($setup["SetExpirationDateHoldRequestModal"], {
      isOpen: $setup.isOpenApproveModal,
      onClose: _cache[4] || (_cache[4] = ($event: any) => ($setup.isOpenApproveModal = false)),
      lotTitle: $setup.lot?.title,
      initialHold: $setup.initialHold,
      isSubmitting: $setup.isModalSubmitting,
      onSubmit: _cache[5] || (_cache[5] = ($event: any) => ($setup.onSetExpirationDateApproveModal($event))),
      minExpirationDays: 2
    }, null, 8, ["isOpen", "lotTitle", "initialHold", "isSubmitting"]),
    _createVNode($setup["SetExpirationDateHoldRequestModal"], {
      onSubmit: _cache[6] || (_cache[6] = ($event: any) => ($setup.onSubmitExtendModal($event))),
      onClose: _cache[7] || (_cache[7] = ($event: any) => ($setup.isExtendModalOpen = false)),
      isOpen: $setup.isExtendModalOpen,
      lotTitle: $setup.lot?.title,
      isSubmitting: $setup.isModalSubmitting,
      initialHold: $setup.initialHold,
      customText: `Please set the amount of days you would like to add to the hold on Lot ${$setup.lot?.title}.`,
      customTitle: `Extend Hold`,
      minExpirationDays: 2
    }, null, 8, ["isOpen", "lotTitle", "isSubmitting", "initialHold", "customText"]),
    _createVNode($setup["ConfirmInitialHoldModal"], {
      isOpen: $setup.isConfirmApproveModalOpen,
      onClose: _cache[8] || (_cache[8] = ($event: any) => ($setup.isConfirmApproveModalOpen = false)),
      onConfirm: $setup.approveHoldRequest,
      hasMoreInitialHolds: $setup.pendingInitialHoldsOnLotCount > 1
    }, null, 8, ["isOpen", "hasMoreInitialHolds"]),
    _createVNode($setup["ConfirmDeleteModal"], {
      isOpen: $setup.isConfirmCancelModalOpen,
      onClose: _cache[9] || (_cache[9] = ($event: any) => ($setup.isConfirmCancelModalOpen = false)),
      deleteItem: `Lot ${$setup.lot?.title}`,
      customText: `Are you sure you would like to cancel this hold request on`,
      onConfirm: _cache[10] || (_cache[10] = ($event: any) => ($setup.isReasonForCancelModalOpen = true))
    }, null, 8, ["isOpen", "deleteItem"]),
    ($setup.initialHold)
      ? (_openBlock(), _createBlock($setup["GiveReasonModal"], {
          key: 2,
          modalTitle: `Add reason for cancel`,
          isOpen: $setup.isReasonForCancelModalOpen,
          reasons: [...Object.values($setup.ReasonsForExpire)],
          onConfirm: _cache[11] || (_cache[11] = ($event: any) => ($setup.onCancelHold($event))),
          onClose: _cache[12] || (_cache[12] = ($event: any) => ($setup.isReasonForCancelModalOpen = false)),
          onSkip: _cache[13] || (_cache[13] = ($event: any) => ($setup.onCancelHold(''))),
          canSkip: ""
        }, null, 8, ["isOpen", "reasons"]))
      : _createCommentVNode("", true),
    ($setup.initialHold)
      ? (_openBlock(), _createBlock($setup["GiveReasonModal"], {
          key: 3,
          modalTitle: `Add reason for declining`,
          isOpen: $setup.isDeclineModalOpen,
          reasons: [...Object.values($setup.ReasonsForDecline)],
          onConfirm: _cache[14] || (_cache[14] = ($event: any) => ($setup.onDeclineHold($event))),
          onSkip: _cache[15] || (_cache[15] = ($event: any) => ($setup.onDeclineHold(''))),
          onClose: _cache[16] || (_cache[16] = ($event: any) => ($setup.isDeclineModalOpen = false)),
          canSkip: "",
          sendReasonToLead: ""
        }, null, 8, ["isOpen", "reasons"]))
      : _createCommentVNode("", true),
    ($setup.initialHold)
      ? (_openBlock(), _createBlock($setup["GiveReasonModal"], {
          key: 4,
          modalTitle: `Add reason for expiration`,
          isOpen: $setup.isReasonForExpiredModalOpen,
          reasons: [...Object.values($setup.ReasonsForExpire)],
          onConfirm: _cache[17] || (_cache[17] = ($event: any) => ($setup.onExpiredHoldReason($event))),
          canSkip: false,
          onClose: _cache[18] || (_cache[18] = ($event: any) => ($setup.isReasonForExpiredModalOpen = false))
        }, null, 8, ["isOpen", "reasons"]))
      : _createCommentVNode("", true)
  ]))
}